"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UITHEMES = exports.UITHEME_DEFAULT = exports.UIMODES = exports.UIMODE_DEFAULT = exports.LANGUAGES = exports.LANGUAGE_DEFAULT = exports.ENDPOINTS = exports.ENDPOINT_DEFAULT = exports.CRYPTOS = void 0;

var _util = require("@polkadot/util");

// Copyright 2017-2019 @polkadot/ui-settings authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.
// matches https://polkadot.js.org & https://poc-3.polkadot.io
const isPolkadot = !(0, _util.isUndefined)(window) && window.location.host.indexOf('polkadot') !== -1;
const WSS_POLKADOT = 'wss://poc3-rpc.polkadot.io/';
const WSS_SUBSTRATE = 'wss://substrate-rpc.parity.io/';
const LANGUAGE_DEFAULT = 'default';
exports.LANGUAGE_DEFAULT = LANGUAGE_DEFAULT;
const CRYPTOS = [{
  text: 'Edwards (ed25519)',
  value: 'ed25519'
}, {
  text: 'Schnorrkel (sr25519)',
  value: 'sr25519'
}];
exports.CRYPTOS = CRYPTOS;
const ENDPOINTS = [{
  text: 'Alexander (Polkadot, hosted by Parity)',
  value: WSS_POLKADOT
}, {
  text: 'Dried Danta (Substrate, hosted by Parity)',
  value: WSS_SUBSTRATE
}, {
  text: 'Local Node (127.0.0.1:9944)',
  value: 'ws://127.0.0.1:9944/'
}];
exports.ENDPOINTS = ENDPOINTS;
const LANGUAGES = [{
  value: LANGUAGE_DEFAULT,
  text: 'Default browser language (auto-detect)'
}];
exports.LANGUAGES = LANGUAGES;
const UIMODES = [{
  value: 'full',
  text: 'Fully featured'
}, {
  value: 'light',
  text: 'Basic features only'
}];
exports.UIMODES = UIMODES;
const UITHEMES = [{
  value: 'polkadot',
  text: 'Polkadot'
}, {
  value: 'substrate',
  text: 'Substrate'
}];
exports.UITHEMES = UITHEMES;
const ENDPOINT_DEFAULT = isPolkadot ? WSS_POLKADOT : WSS_SUBSTRATE;
exports.ENDPOINT_DEFAULT = ENDPOINT_DEFAULT;
const UITHEME_DEFAULT = isPolkadot ? 'polkadot' : 'substrate';
exports.UITHEME_DEFAULT = UITHEME_DEFAULT;
const UIMODE_DEFAULT = !isPolkadot && !(0, _util.isUndefined)(window) && window.location.host.indexOf('ui-light') !== -1 ? 'light' : 'full';
exports.UIMODE_DEFAULT = UIMODE_DEFAULT;